var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGamesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 77,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16a7 7 0 0 0-3.5 9.3L17.1 60a6.4 6.4 0 0 0 8.5 3.2l6.8-3.6a2.4 2.4 0 0 0 .9-3.3c-.4-.7-.4-1.5-.1-2.2l7.2-16.8 7.2-16.1 3.2-7.3c.1-.2.3-.4.6-.5.5 0 .7-.6.5-1l-3.6-8.2A7 7 0 0 0 39 .6L5 16Zm33.4 4.6a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Zm-16.7 4.2a6.3 6.3 0 1 1-12.6 0 6.3 6.3 0 0 1 12.6 0Zm5.2 30.5a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6ZM62.7 14a7 7 0 0 0-9.3 3.6L38.1 51.8a7 7 0 0 0 3.6 9.2l34 15.4a7 7 0 0 0 9.3-3.5l15.3-34.3a7 7 0 0 0-3.5-9.2L62.7 14Zm-.2 20.3a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Zm12.6 10.5a6.3 6.3 0 1 1-12.6 0 6.3 6.3 0 0 1 12.6 0Zm1 23.1a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGamesIcon);
export default __webpack_public_path__ + "static/media/menu-games-icon.16c1123d3c66d6fa6ace6079121ea446.svg";
export { ForwardRef as ReactComponent };